import { MutationTree } from 'vuex'
import { ProsumerBonusState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<ProsumerBonusState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
